import { StorageKeys } from "src/core/analytics/dataMesh/common/enums";
import { dataMeshParamsStorage } from "src/core/analytics/dataMesh/utils/dbMethods/dataMeshParamsStorage";

export const clearEventBuffer = async () =>
  dataMeshParamsStorage.removeItem(StorageKeys.SESSION_BUFFER);
